import { useMutation, useQueryClient } from 'react-query';
import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { ILandingPageBuilderBulkEditPayload } from 'app/pages/admin/landing-pages-v2/helpers/getInitialLandingPageValuesForBulkEdit';

interface IEditBatchTemplatesInGroupParams {
  groupId: number;
  data: Partial<Partial<ILandingPageBuilderBulkEditPayload>>;
}

const editBatchTemplatesInGroup = async (
  params: IEditBatchTemplatesInGroupParams
) => {
  const { groupId, data } = params;
  return await EXPRESS_API.patch(
    `/superadmin/landing-page-design-groups/${groupId}/edit-batch`,
    data
  );
};

export const useEditBatchTemplatesInGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(
    (params: IEditBatchTemplatesInGroupParams) =>
      editBatchTemplatesInGroup(params),
    {
      onSuccess: async () => {
        await queryClient.refetchQueries({
          queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
          exact: false,
        });
        await queryClient.refetchQueries({
          queryKey: 'LANDING_PAGE_DESIGN_GROUP',
          exact: false,
        });
        if (onSuccess) onSuccess();
        successToast({
          title: 'The group templates have been successfully updated!',
        });
      },
      onError: error => {
        showError(
          error || 'An error occured while trying to edit the group templates!'
        );
      },
    }
  );
};
